import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  playlistName: {
    color: '#230B4C',
    fontSize: '22px',
    fontWeight: 'bold',
    width: '100%',
    marginBottom: 24,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.8rem'
    }
  },
  playlistContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: 'linear-gradient(#1DB6FD, #230B4C);',
    padding: 60,
    minHeight: '100vh'
  },
  root: {
    padding: '30px 20px 20px 20px',
    width: '850px',
    height: '850px',
    minHeight: '850px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '12px',
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100vw - 25px)',
      padding: '15px'
    }
  }
}))
